"use client";

import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurRawPhilosophy() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const purposes = [{
    id: 1,
    text: "Ολοκλήρωση και διαχείριση της κράτησής σας."
  }, {
    id: 2,
    text: "Αποστολή επιβεβαίωσης και ενημερώσεων για την κράτηση."
  }, {
    id: 3,
    text: "Βελτίωση των υπηρεσιών μας και εξατομίκευση της εμπειρίας σας."
  }];
  return <section data-section-id="1284" id="πώς-χρησιμοποιούμε-τα-δεδομένα" className="relative bg-background text-foreground overflow-hidden py-32 md:py-44">
      <div className="relative container mx-auto px-6 md:px-12 max-w-[1600px]">
        <div ref={contentRef} className="max-w-4xl transition-all duration-[520ms] ease-out" style={{
        opacity: contentVisible ? 1 : 0,
        transform: contentVisible ? "translateY(0)" : "translateY(24px)"
      }}>
          <div className="flex items-center gap-4 mb-10">
            <span className="font-mono text-xs md:text-sm font-medium uppercase tracking-[0.18em]" style={{
            color: "var(--primary)"
          }}>
              § 03 / ΣΚΟΠΟΣ ΕΠΕΞΕΡΓΑΣΙΑΣ
            </span>
            <div className="h-px w-10" style={{
            backgroundColor: "var(--border)"
          }} />
          </div>

          <h2 className="font-default font-semibold uppercase mb-12" style={{
          fontSize: "clamp(2.5rem, 6vw, 4.5rem)",
          lineHeight: 1.1,
          letterSpacing: "-0.02em"
        }}>
            ΠΩΣ ΧΡΗΣΙΜΟΠΟΙΟΥΜΕ ΤΑ <span style={{
            color: "var(--primary)"
          }}>ΔΕΔΟΜΕΝΑ</span> ΣΑΣ
          </h2>

          <div className="space-y-8">
            {purposes.map((purpose, i) => <div key={purpose.id} data-index={i} className="flex items-start gap-6 group">
                <div className="mt-1 flex size-8 shrink-0 items-center justify-center border border-primary/20 bg-primary/5 transition-colors group-hover:bg-primary/10">
                  <Check className="size-5" style={{
                color: "var(--primary)"
              }} strokeWidth={2.5} />
                </div>
                <p className="font-sans text-lg md:text-xl leading-relaxed" style={{
              color: "var(--muted-foreground)"
            }}>
                  {purpose.text}
                </p>
              </div>)}
          </div>

          <div className="mt-16 pt-12 border-t border-border/50">
            <p className="font-sans text-sm uppercase tracking-widest opacity-50">
              PROTOCOL 03 / DATA PROCESSING PURPOSE
            </p>
          </div>
        </div>
      </div>

      {}
      <div className="absolute -bottom-24 -right-24 size-96 rounded-lg opacity-[0.03] pointer-events-none" style={{
      backgroundColor: "var(--primary)"
    }} aria-hidden="true" />
    </section>;
}